/**
 * Возвращает дату в SQL формате
 * @param {Date} jsDate
 * @returns {string}
 */
export function getSQLDate(jsDate: Date, utc = false) {
  let offset = 0;
  if (!utc) {
    const timeOffset = new Date().getTimezoneOffset();
    offset = timeOffset * 60000;
  }
  return new Date(jsDate.getTime() - offset).toISOString().substr(0, 19).replace('T', ' ');
}

/**
 * Возвращает дату для использования в datetime-local инпуте
 * @param {Date} jsDate
 * @returns {string}
 */
export function getInputDate(jsDate: Date, onlyDate = false): string {
  const timeOffset = new Date().getTimezoneOffset();
  return new Date(jsDate.getTime() - timeOffset * 60000)
    .toISOString()
    .substr(0, onlyDate ? 10 : 16);
}

export const formattedLocaleTime = (date: Date) => {
  return date.toLocaleTimeString(undefined, { timeStyle: 'short' });
};

export const dateRangeToLocaleString = (d1: Date, d2: Date, withTime = true) => {
  const d1parts: string[] = [];
  const d2parts: string[] = [];
  const currentDate = new Date();

  const isCurrentYear = d1.getFullYear() === currentDate.getFullYear();

  const isOneDay = d1.toLocaleDateString() === d2.toLocaleDateString();
  //const isOneMonth = d1.toISOString().substring(0, 7) === d2.toISOString().substring(0, 7);
  const isOneYear = d1.getFullYear() === d2.getFullYear();

  d1parts.push(
    d1.toLocaleDateString('default', {
      month: 'short',
      day: 'numeric',
      year: isCurrentYear ? undefined : 'numeric',
    }),
  );

  if (withTime) {
    d1parts.push(d1.toLocaleTimeString('default', { minute: '2-digit', hour: '2-digit' }));
  }

  if (!isOneDay) {
    d2parts.push(
      d2.toLocaleDateString('default', {
        day: isOneDay ? undefined : 'numeric',
        month: isOneDay ? undefined : 'short',
        year: isOneYear ? undefined : 'numeric',
      }),
    );
  }

  if (withTime) {
    d2parts.push(d2.toLocaleTimeString('default', { minute: '2-digit', hour: '2-digit' }));
  }

  return [d1parts.join('\u00a0'), d2parts.join('\u00a0')].filter(Boolean).join(' – ');
};

export const getDateFromSQLAsUTC = (sqlDate: string): Date => {
  return new Date(sqlDate.replace(/\s/, 'T') + '.000Z');
};

export const getDiffDate = (d1: Date, d2: Date): Date => {
  return new Date(d2.getTime() - d1.getTime() + new Date().getTimezoneOffset() * 60000);
};

export default {
  getSQLDate,
  getInputDate,
};

export const firstDateOfMonth = (date = new Date()) =>
  new Date(date.getFullYear(), date.getMonth(), 1);

export const lastDateOfMonth = (date = new Date()) =>
  new Date(date.getFullYear(), date.getMonth() + 1, 0);

export const getWeekDay = (date = new Date()) => (date.getDay() + 6) % 7;
export const getISODay = (date = new Date(), utc = true) => {
  let offset = 0;
  if (!utc) {
    const timeOffset = new Date().getTimezoneOffset();
    offset = timeOffset * 60000;
  }
  return new Date(date.getTime() - offset).toISOString().substring(0, 10);
};

export const weekCount = (date: Date) => {
  const firstOfMonth = firstDateOfMonth(date);
  const lastOfMonth = lastDateOfMonth(date);

  const dayOffset = (firstOfMonth.getDay() - 1 + 7) % 7;
  const used = dayOffset + lastOfMonth.getDate();

  return Math.ceil(used / 7);
};
